import './css/site.css';
import { configureStore } from '@reduxjs/toolkit'
import { appInsights } from './appInsights';
import * as React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ShowHoversOnMouseDevices } from './ShowHoversOnMouseDevices';
import { Layout } from './components/Layout';
import { ScrollToTop } from './components/ScrollToTop';
import { registerLocale } from 'react-datepicker';
import {nl, enGB}  from 'date-fns/locale';
import { ClientState } from './_generatedTypes.g';
import { createRoot } from 'react-dom/client';
import languageSlice, { languageChanged } from './features/language/languageSlice';
import Cookies from 'js-cookie';
import searchSlice from './features/search/searchSlice';
import operationSlice from './features/utils/operationSlice';
import homeSlice from './features/home/homeSlice';
import electionScreenSlice from './features/election/electionScreenSlice';
import candidateEditSlice from './features/candidate/candidateEditSlice';
import candidatesSlice from './features/candidate/candidatesSlice';
import { innerStateSet } from './features/innerState/innerStateSlice';
import electionsSlice from './features/election/electionsSlice';
import partiesSlice from './features/party/partiesSlice';
import partyEditSlice from './features/party/partyEditSlice';
import PartyScreenSlice from './features/party/PartyScreenSlice';
import PartyAdminScreenSlice from './features/partyadmin/PartyAdminScreenSlice';
import clientStateSlice from './features/innerState/innerStateSlice';

appInsights.trackPageView();

ShowHoversOnMouseDevices();

// If devTools is installed, connect to it
//const devToolsExtension = (window as any).__REDUX_DEVTOOLS_EXTENSION__;

// Combine all reducers and instantiate the app-wide store instance
const store = configureStore({
  // Automatically calls `combineReducers`
  reducer: {
    language: languageSlice,
    searchItemState: searchSlice,
    editingCandidateById: candidateEditSlice,
    editingPartyById: partyEditSlice,
    elections: electionsSlice,
    parties: partiesSlice,
    candidates: candidatesSlice,
    homeScreen: homeSlice,
    electionScreen: electionScreenSlice,
    partyScreen: PartyScreenSlice,
    partyAdminScreen: PartyAdminScreenSlice,
    operationStatus: operationSlice,
    clientState: clientStateSlice,
  }
})

const state = JSON.parse(document.body.getAttribute('data-state')!) as ClientState;
store.dispatch(innerStateSet(state));

store.dispatch(languageChanged( Cookies.get('.AspNetCore.Culture') === 'c=en-GB|uic=en-GB' ? 'EN' : 'NL'));
registerLocale('nl-NL', nl);
registerLocale('en-GB', enGB);
// This code starts up the React app when it runs in a browser. It sets up the routing configuration
// and injects the app into a DOM element.
const container = document.getElementById('react-app');
const root = createRoot(container!); 
root.render(
    <Provider store={store}>
        <BrowserRouter>
            <ScrollToTop>
                <Layout/>
            </ScrollToTop>
        </BrowserRouter>
    </Provider>
);
